export default {"src":"/_next/static/media/overheadEquipmentLabels.8e22a5e0.svg","height":2475,"width":2251,"blurWidth":0,"blurHeight":0};